/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetImportsTableDatabaseHeadingStyles = makeStyles(theme => ({
  cell: {
    height: 'auto',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  databaseNameCell: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 'bold',
  },
  collapseIconButton: {
    padding: 0,
  },
  collapseIconButtonCell: {
    width: '32px',
  },
}));
